"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _closeButton = _interopRequireDefault(require("../../close-button"));
require("./styles.css");
var _excluded = ["className"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var OverlayCloseButton = function OverlayCloseButton(_ref) {
  var _ref$closeCallback = _ref.closeCallback,
    closeCallback = _ref$closeCallback === void 0 ? function () {} : _ref$closeCallback,
    _ref$closeModal = _ref.closeModal,
    closeModal = _ref$closeModal === void 0 ? function () {} : _ref$closeModal,
    _ref$closeProps = _ref.closeProps,
    className = _ref$closeProps.className,
    closeButtonProps = _objectWithoutProperties(_ref$closeProps, _excluded),
    _ref$isDarkTheme = _ref.isDarkTheme,
    isDarkTheme = _ref$isDarkTheme === void 0 ? false : _ref$isDarkTheme,
    isDialogVariant = _ref.isDialogVariant,
    isImageVariant = _ref.isImageVariant;
  var closeButtonClasses = (0, _classnames["default"])('sb-overlay__closeBtn color-textBlackSoft', className, {
    'position-absolute': isDialogVariant || isImageVariant
  });
  var button = /*#__PURE__*/_react["default"].createElement(_closeButton["default"], _extends({
    className: closeButtonClasses,
    "data-is-close-button": true,
    highContrast: isImageVariant || isDarkTheme,
    onClick: function onClick() {
      closeModal();
      closeCallback();
    }
  }, closeButtonProps));
  if (isDialogVariant || isImageVariant) {
    return button;
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-right sb-overlay__closeBtnContainer sb-global-gutters"
  }, button);
};
OverlayCloseButton.propTypes = process.env.NODE_ENV !== "production" ? {
  closeCallback: _propTypes["default"].func,
  closeProps: _propTypes["default"].object,
  isImageVariant: _propTypes["default"].bool
} : {};
var _default = exports["default"] = OverlayCloseButton;